/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const responseApiKeyDeviceSchema = z
	.object({
		api_key: z.string(),
	})
	.describe("Для документации, сериализатор вывода api-key для устройства.");
